import React from "react";

// mui components
import { TableCell, TableRow } from "@mui/material";

// custom components
import Body3 from "../../typography/body-03";
import Body2 from "../../typography/body-02";

// custom styles
import styles from "../index.module.scss";

const EligibleProductAdjustmentsRow = ({
	id,
	row,
	rowData,
	extraData,
	hideAdjustmentPriceColumn = false,
}) => {
	console.log("15 extra data:", id, extraData);
	console.log("15 row data:", rowData);

	// last or second last row
	let finalOrTotal = id === rowData?.length - 1 || id === rowData?.length - 2;

	return (
		<TableRow hover tabIndex={-1} className={styles.rowContainer}>
			<TableCell>
				{finalOrTotal ? (
					<Body2
						text={row?.reason}
						extraClass={styles.greenText}
						fontType="semibold"
					/>
				) : (
					<Body3 text={row?.reason} extraClass={styles.greenText} />
				)}
			</TableCell>
			{!hideAdjustmentPriceColumn && (
				<TableCell align="right">
					{finalOrTotal ? (
						<Body3
							text={Number(row?.adjustor)?.toFixed(3)}
							extraClass={styles.greenText}
						/>
					) : (
						<Body3
							text={
								row?.type?.toLowerCase()?.includes("price")
									? `${Number(row?.adjustor)?.toFixed(3)}%`
									: "0.000%"
							}
							extraClass={styles.greenText}
						/>
					)}
				</TableCell>
			)}
		</TableRow>
	);
};

export default EligibleProductAdjustmentsRow;
